import "./GraphActions.css";

import { Badge, Box, ButtonIcon, Icon, Tooltip } from "@saviynt/design-system";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";

import { type AccessMapSuccessResponse } from "../../types";

export default function GraphActions({
  setIsSearchSidePanelOpen,
  setIsCriticalHighRiskSidePanelOpen,
  isSearchSidePanelOpen,
  isCriticalHighRiskSidePanelOpen,
  data,
}: {
  setIsSearchSidePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsCriticalHighRiskSidePanelOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  isSearchSidePanelOpen: boolean;
  isCriticalHighRiskSidePanelOpen: boolean;
  data: AccessMapSuccessResponse;
}) {
  const intl = useIntl();

  const [selected, setSelected] = useState<"search" | "criticalHighRisk" | "">(
    "",
  );

  const findingsCount = useMemo(() => {
    let count = 0;

    data.data.nodes.forEach((node) => {
      count += node.policyViolationDetails?.length;
    });

    return count;
  }, [data]);

  useEffect(() => {
    if (!isSearchSidePanelOpen && !isCriticalHighRiskSidePanelOpen) {
      setSelected("");
    }
  }, [isSearchSidePanelOpen, isCriticalHighRiskSidePanelOpen]);

  return (
    <div
      className="Nhi-AccessMap-Actions"
      role="toolbar"
      aria-label={intl.formatMessage({
        defaultMessage: "Access map actions",
        description: "Aria label for access map actions toolbar",
        id: "MNQjxO",
      })}
    >
      <Tooltip
        trigger={
          <ButtonIcon
            ariaLabel=""
            className="search-access-map"
            size="medium"
            kind="outlinedSecondary"
            isSelected={selected === "search"}
            icon={<Icon kind="Search" size="xSmall" />}
            onClick={() => {
              setSelected("search");
              setIsSearchSidePanelOpen(true);
            }}
          />
        }
        text={intl.formatMessage({
          defaultMessage: "Search",
          id: "XpUrPT",
          description:
            "Label for the search input field to find inventory items",
        })}
        placement="top-start"
      />

      <Tooltip
        trigger={
          <div className="risk-wrapper">
            <ButtonIcon
              size="medium"
              kind="outlinedSecondary"
              isSelected={selected === "criticalHighRisk"}
              icon={<Icon kind="CriticalHighRiskHexagon" size="xSmall" />}
              ariaLabel={intl.formatMessage({
                defaultMessage: "Top Findings",
                id: "H4YAXf",
                description:
                  "Button label for accessing critical and high risk items in the access map",
              })}
              onClick={() => {
                setSelected("criticalHighRisk");
                setIsCriticalHighRiskSidePanelOpen(true);
              }}
            />
            {findingsCount ? (
              <Box className="risk-count-badge">
                <Badge
                  color="error"
                  kind="number"
                  size="small"
                  number={findingsCount}
                />
              </Box>
            ) : null}
          </div>
        }
        text={intl.formatMessage({
          defaultMessage: "Top Findings",
          id: "XanAay",
          description:
            "Tooltip text for the top Findings button in the access map",
        })}
        placement="top-start"
      />
    </div>
  );
}
